import {Routes} from '@angular/router';

import {MapComponent} from './components/map/map.component';
import {SpotDetailsComponent} from './components/spot-details/spot-details.component';
import {CmsComponent} from './components/cms/cms.component';

export const ROUTES: Routes = [
  {path: '', component: MapComponent},
  {path: 'spot/:id', component: SpotDetailsComponent},
  {path: 'map/:id', component: MapComponent},
  {path: 'cms', component: CmsComponent},
];



// WEBPACK FOOTER //
// C:/Users/muth/Documents/privat/angular/guidr/src/app/routes.ts